export default __webpack_public_path__ + "static/media/P800_23A800B.da3f7aa9.STEP";